import { IGenerateToken, IGenerateTokenRes } from '@/interfaces/token';
import * as baseAdapter from './baseAdapter';

export const generateToken = async (req: IGenerateToken) => {
  const ret = await baseAdapter.post<IGenerateTokenRes>(
    '/v1/auth/generate-token',
    req
  );
  return ret;
};
